// import React from "react"

import { calenderDefaultCategories, events } from "./calender"
import { chats, contacts, groups, messages } from "./chat"
import {
  cartData,
  comments,
  customerData,
  discountData,
  colorData,
  orderData,
  productsData,
  shops,
  productListvar,
  orderSummary,
} from "./ecommerce"
import { invoiceList } from "./invoices"
import { users, userProfile } from "./contacts"
import { statuses, verticalTimelineData, pricings } from "./utility"
export {
  events,
  calenderDefaultCategories,
  chats,
  groups,
  contacts,
  messages,
  cartData,
  comments,
  customerData,
  discountData,
  colorData,
  orderData,
  productsData,
  shops,
  invoiceList,
  users,
  userProfile,
  statuses,
  verticalTimelineData,
  pricings,
  productListvar,
  orderSummary,
 
}
